import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CompanyComment, CompanyCommentsPage, CompanyProfile } from '../interfaces/company-profile';
import { JobFilterParams } from '../../jobs/services/job-list.service';


@Injectable({
  providedIn: 'root'
})
export class CompanyProfileService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getCompanyProfile(companyId: string): Observable<CompanyProfile> {
    return this.http.get<CompanyProfile>(`${this.baseUrl}api/company/${companyId}/public`);
  }
 getCompanyComments(companyId: string, page: number = 0, size: number = 10): Observable<CompanyCommentsPage> {
  return this.http.get<CompanyCommentsPage>(
    `${this.baseUrl}api/companies/${companyId}/comments/approved?page=${page}&size=${size}`
  );
}
  addCompanyComment(companyId: string, content: string, rate: number): Observable<any> {
  const token = localStorage.getItem('accessToken');
  const headers = { Authorization: `Bearer ${token}` };
  return this.http.post(
    `${this.baseUrl}api/companies/${companyId}/comments`,
    { content, rate },
    { headers }
  );
}
 getCompanyJobs(
    companyId: string,
    filters: JobFilterParams = {},
  ): Observable<any> {
    let params = new HttpParams()
      .set('page', String(filters.page ?? 0))
      .set('size', String(filters.size ?? 10));

    if (filters.minExperience != null) {
      params = params.set('minExperience', String(filters.minExperience));
    }
    if (filters.maxExperience != null) {
      params = params.set('maxExperience', String(filters.maxExperience));
    }

    filters.salaryFilters?.forEach((sf, i) => {
      if (sf.minSalary != null) {
        params = params.set(`salaryFilters[${i}].minSalary`, String(sf.minSalary));
      }
      if (sf.maxSalary != null) {
        params = params.set(`salaryFilters[${i}].maxSalary`, String(sf.maxSalary));
      }
      params = params.set(`salaryFilters[${i}].salaryType`, sf.salaryType);
    });

    filters.jobTypes?.forEach((type) => {
      params = params.append('jobTypes', type);
    });

    filters.postTypes?.forEach((type) => {
      params = params.append('postTypes', type);
    });

    filters.careerLevels?.forEach((level) => {
      params = params.append('careerLevels', level);
    });

    if (filters.postingDate) {
      params = params.set('postingDate', filters.postingDate);
    }
    if (filters.location) {
      params = params.set('location', filters.location);
    }
    if (filters.position) {
      params = params.set('position', filters.position);
    }
    if (filters.department) {
      params = params.set('department', filters.department);
    }

    return this.http.get<any>(
      `${this.baseUrl}api/job-posts/company/${companyId}`,
      { params }
    );
  }
}
